import React from 'react';
import PriceHistory from '../../../product/components/price-history';
import { ProductAlertFormData } from '../../types';

import * as S from './styles';

interface PriceTrendProps {
  productAlertFormData: ProductAlertFormData;
  withoutGraph?: boolean;
}

const PriceTrend = (props: PriceTrendProps) => {
  const { productAlertFormData, withoutGraph } = props;
  const product = productAlertFormData.product;

  const futurePrices =
    product?.priceForecast && product?.priceForecast.length > 0
      ? product?.priceForecast
      : [];

  return (
    <S.PriceTrend>
      {!withoutGraph && (
        <PriceHistory {...product?.statistics} predictedPrices={futurePrices} />
      )}
    </S.PriceTrend>
  );
};

export default PriceTrend;
